// extracted by mini-css-extract-plugin
export default {"list":"breadcrumbs_list__0ZqIB","item":"breadcrumbs_item__VJQ8d","link":"breadcrumbs_link__haMV7"};